import { compose } from 'recompose';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { selectNameSuffixesList } from '../../../redux/data/selectors';
import {
  selectSavedPatientContacts,
  selectSavedPatientPersonalInfo,
} from '../../../redux/profiles/selectors';
import styles from './index.styl';

const mapStateToProps = state => ({
  patientContacts: selectSavedPatientContacts(state),
  personalInfo: selectSavedPatientPersonalInfo(state),
  nameSuffixList: selectNameSuffixesList(state),
});

export const enhance = compose(
  connect(
    mapStateToProps,
    null,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientRegistrationInfo/enhance.js